/**
 * TOP ビジュアルフェードスライダー
 * 複数背景画像を opacity のクロスフェードで自動切り替え（ナビ UI なし）
 */
(function () {
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const SECTION_SELECTOR = '[data-top-visual-fade-slider-section]';
  const SLIDE_SELECTOR = '[data-visual-fade-slider-slide]';
  const ACTIVE_CLASS = 'is-active';
  const REDUCED_MOTION_CLASS = 'is-reduced-motion';

  /**
   * 背景スライドの自動フェード切り替えを開始する
   * @param {HTMLElement} sectionRoot
   * @param {NodeListOf<HTMLElement>} slides
   */
  function startSlideRotation(sectionRoot, slides) {
    if (slides.length < 2) {
      return;
    }

    const intervalSeconds = parseFloat(
      getComputedStyle(sectionRoot).getPropertyValue('--top-visual-fade-slider-slide-interval')
    );
    const intervalMs = (Number.isFinite(intervalSeconds) ? intervalSeconds : 6) * 1000;
    let activeIndex = 0;

    slides.forEach((slide, index) => {
      slide.classList.toggle(ACTIVE_CLASS, index === activeIndex);
    });

    window.setInterval(() => {
      slides[activeIndex].classList.remove(ACTIVE_CLASS);
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add(ACTIVE_CLASS);
    }, intervalMs);
  }

  /**
   * 1セクション分を初期化する
   * @param {HTMLElement} sectionRoot
   */
  function initTopVisualFadeSliderSection(sectionRoot) {
    if (sectionRoot.dataset.visualFadeSliderInitialized === 'true') {
      return;
    }

    sectionRoot.dataset.visualFadeSliderInitialized = 'true';

    const prefersReducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;
    const slides = sectionRoot.querySelectorAll(SLIDE_SELECTOR);

    if (prefersReducedMotion) {
      sectionRoot.classList.add(REDUCED_MOTION_CLASS);
      slides.forEach((slide, index) => {
        slide.classList.toggle(ACTIVE_CLASS, index === 0);
      });
      return;
    }

    startSlideRotation(sectionRoot, slides);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initTopVisualFadeSliderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target.querySelector(SECTION_SELECTOR);

    if (sectionRoot) {
      initTopVisualFadeSliderSection(sectionRoot);
    }
  });
})();
